'use client';

import { useSalePageQuery } from '@/entities/salePage';
import { Element, IconButton } from '@vuddy/components';
import { trackEvent } from '@vuddy/utils';
import { format } from 'date-fns';
import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';

const getDate = () => {
  return format(new Date(), 'yyyy.MM.dd HH:mm:ss');
};

export const GachaPosibilityDate = () => {
  const params = useParams();
  const { salePageId } = params;
  const { refetch, isFetching } = useSalePageQuery(
    salePageId as unknown as number
  );
  const [date, setDate] = useState<string>('');

  useEffect(() => {
    if (!isFetching) {
      setDate(getDate());
    }
  }, [isFetching]);

  const handleClick = () => {
    trackEvent('sales', 'click_probability_info_refresh');
    refetch();
  };

  return (
    <Element display="flex" justifyContent="center" alignItems="center">
      <Element typography="captionBase" color="whiteSecondary">
        {date}
      </Element>
      <IconButton
        onClick={handleClick}
        icon={{
          name: 'OUTLINE_RELOAD',
          size: '16px',
          color: 'whiteSecondary',
        }}
      />
    </Element>
  );
};
